<template>
  <topbar
    :titulo="$t('ACADEMICO_HOME.FECHAMENTO_CURSO_TURMA')"
    :subtitulo="$t('ACADEMICO_HOME.FECHAMENTO_CURSO_TURMA_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>
    <script>
// Utils & Aux:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO_HOME.PAINEL_ACADEMICO') },
        { titulo: this.$t('ACADEMICO_HOME.FECHAMENTO_CURSO_TURMA') },
      ],
    };
  },
};
</script>
    